<template>
    <v-form ref="form">
        <v-row>
            <v-col>
                <v-text-field
                    outlined
                    dense
                    hide-details="auto"
                    label="First Name"
                    v-model="form.first_name"
                    :rules="[isRequired]"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    outlined
                    dense
                    hide-details="auto"
                    label="Last Name"
                    v-model="form.last_name"
                    :rules="[isRequired]"
                ></v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    outlined
                    dense
                    hide-details="auto"
                    label="Email"
                    v-model="form.email"
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    outlined
                    dense
                    hide-details="auto"
                    label="Phone"
                    v-model="form.phone"
                >

                </v-text-field>
            </v-col>
        </v-row>
        <v-row v-if="!editMode">
            <v-col>
                <v-text-field
                    outlined
                    dense
                    hide-details="auto"
                    label="Username"
                    v-model="form.username"
                    :rules="[isRequired]"
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-switch
                    class="ma-0"
                    dense
                    label="Must Change Password"
                    v-model="form.must_change_password"
                    hide-details="audo"
                >
                </v-switch>
            </v-col>
        </v-row>
         <v-row v-if="editMode">
            <v-col>
                <v-switch
                    class="ma-0"
                    dense
                    label="Deactivate"
                    v-model="form.inactive"
                    hide-details="auto"
                >
                </v-switch>
            </v-col>
        </v-row>
        <v-row>
            <v-col v-if="editMode">
                <v-switch
                    class="ma-0"
                    dense
                    label="Change Password"
                    v-model="changePassword"
                    hide-details="auto"
                >
                </v-switch>
            </v-col>
        </v-row>
        <v-row v-if="!editMode || changePassword">
            <v-col>
                <v-text-field
                    outlined
                    dense
                    hide-details="auto"
                    label="Password"
                    v-model="form.password"
                    :rules="[isRequired]"
                    :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPassword = !showPassword"
                    :type="showPassword ? 'text' : 'password'"  
                >
                </v-text-field>
            </v-col>
        </v-row>
        <v-row v-if="!editMode || changePassword">
            <v-col>
                <v-text-field
                    outlined
                    dense
                    hide-details="auto"
                    label="Confirm Password"
                    v-model="form.password_confirmation"
                    :rules="[isRequired]"
                    :append-icon="showPasswordConfirmation ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPasswordConfirmation = !showPasswordConfirmation"
                    :type="showPasswordConfirmation ? 'text' : 'password'"
                >
                </v-text-field>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { isRequired, isNumeric } from './../../utils/validations'
export default {
    props: {
        value: Object
    },
    data() {
        return {
            isRequired,
            isNumeric,
            form: {
                first_name: null,
                last_name: null,
                email: null,
                phone: null,
                must_change_password: null,
                username: null,
                password: null,
                password_confirmation: null,
                inactive: null

            },
            showPassword: false,
            showPasswordConfirmation: false,
            changePassword: false
        }
    },
    computed: {
        editMode() {
            return this.value && this.value.id;
        }
    },
    methods: {
        validate() {
            return this.$refs.form.validate()
        }
    },
    watch: {
        form: {
            deep:true,
            handler(form) {
                this.$emit("input", {...form})
            }
        }
    },
    created() {
        if(this.value) {
            this.form = { ...this.form, ...this.value}
        }
    }
}
</script>

<style>

</style>